import { FC } from "react";
import SelectComponent, {
  SelectComponentProps,
} from "../Select/SelectComponent";
import { Flex } from "@chakra-ui/react";

interface SelectGroupProps {
  selectComponents: SelectComponentProps[];
  spaceBetween?: number;
  flexSize?: number;
  width?: string;
}

const SelectGroup: FC<SelectGroupProps> = ({
  selectComponents,
  spaceBetween = 4,
  flexSize,
  width,
}) => {
  return (
    <Flex
      justifyContent="flex-start"
      alignItems="flex-start"
      gap={spaceBetween}
      flex={flexSize}
      width={width}
    >
      {selectComponents.map((props, index) => (
        <SelectComponent key={index} {...props} />
      ))}
    </Flex>
  );
};

export default SelectGroup;
